export const convertToTaxonomyCase = (value: any) => {
  if (typeof value === 'string') {
    return value.toLowerCase().replace('_', ' ');
  }

  return value;
};
